<template>
  <v-row no-gutters>
    <v-navigation-drawer
      hide-overlay
      permanent
      color="transparent"
      :right="$vuetify.rtl"
      style="z-index: 0 !important"
      height="600"
    >
      <template v-slot:prepend>
        <v-text-field
          v-model="materialCategoriesSearch"
          class="me-2"
          :loading="materialCategoriesLoading"
        >
        </v-text-field>
      </template>

      <v-sheet>
        <v-treeview
          :items="materialCategoriesFiltered"
          :search="materialCategoriesSearch"
          :open.sync="open"
          :active.sync="active"
          item-key="id"
          item-children="categories"
          open-all
          dense
          shaped
          hoverable
          activatable
          return-object
        >
        </v-treeview>
      </v-sheet>
    </v-navigation-drawer>

    <v-col>
      <ValidationObserver ref="observer">
        <v-data-iterator
          height="600"
          :items="materials"
          disable-pagination
          hide-default-footer
          class="pt-1"
        >
          <template v-slot:no-data>
            <v-row class="pt-2">
              <v-spacer />
              <span class="subtitle-2 grey--text">
                {{ $t("$vuetify.noDataText") }}
              </span>
              <v-spacer />
            </v-row>
          </template>
          <template v-slot:no-result>
            <v-row class="pt-2">
              <v-spacer />
              <span class="subtitle-2 grey--text">
                {{ $t("$vuetify.noDataText") }}
              </span>
              <v-spacer />
            </v-row>
          </template>
          <template v-slot:header>
            <v-progress-linear
              v-if="materialsLoading"
              :indeterminate="materialsLoading"
              class="mt-n1"
            ></v-progress-linear>
          </template>
          <!-- materials -->
          <template v-slot:default="props">
            <v-row no-gutters class="mt-n1">
              <v-col v-for="item in props.items" :key="item.id" cols="12">
                <v-card tile elevation="0">
                  <v-row no-gutters>
                    <!-- 图片 -->
                    <v-avatar
                      tile
                      color="bgGrey"
                      style="vertical-align: top"
                      class="ma-1"
                    >
                      <v-menu open-on-hover>
                        <template v-slot:activator="{ on, attrs }">
                          <v-img
                            v-bind="attrs"
                            v-on="on"
                            v-if="item.material.thumbnail"
                            alt="Avatar"
                            :src="item.material.thumbnail"
                          />
                        </template>
                        <v-img :src="item.material.material_img" width="180" />
                      </v-menu>
                    </v-avatar>

                    <v-col>
                      <v-row no-gutters>
<!--                        {{-->
<!--                          settings.material_name_display_type == 3 ||-->
<!--                          settings.material_name_display_type == 2-->
<!--                            ? $t("Material.materialNameWithCode", [-->
<!--                                item.material.material_code,-->
<!--                                item.material.material_name,-->
<!--                                item.material.standard_name,-->
<!--                              ])-->
<!--                            : item.material.material_name-->
<!--                        }}-->
                        {{
                          $t(
                            settings
                              ? settings.material_name_display_type == 4
                                ? "Material.nameWithCodeAndStandard"
                                : settings.material_name_display_type == 3
                                ? "Material.materialNameWithCodeAndStandard"
                                : settings.material_name_display_type == 2
                                ? "Material.materialNameWithCode"
                                : "Material.materialName"
                              : "Material.materialName",
                              [item.material.material_code, item.material.material_name, item.material.standard_name]
                          )
                        }}
                        <v-spacer />
                      </v-row>

                      <v-row no-gutters style="top" class="mt-1">
                        <span class="subtitle-2 secondary--text">
                          {{
                            $t("Question.questionDetail.Fields.supply_price")
                          }}
                          {{ $t("Global.colon") }}
                          {{ $t("Global.money") }}
                          {{ item.supply_price | formatMoney }}
                        </span>
                        <v-spacer />
                        <ValidationProvider v-slot="{ errors }">
                          <v-text-field
                            @input="itemNumChange(item, $event)"
                            :error-messages="errors"
                            :value="
                              orderDetailsMap[item.material_id]
                                ? orderDetailsMap[item.material_id]
                                    .new_supply_price
                                : item.new_supply_price
                            "
                            @blur="
                              item.new_supply_price
                                ? (item.new_supply_price =
                                    $numberFormatter.formatWithDotNoMoreThan(
                                      item.new_supply_price,
                                      2
                                    ))
                                : ''
                            "
                            dense
                            class="mt-n1"
                            hide-details
                            type="number"
                            min="0"
                            :prefix="$t('Global.money')"
                            style="max-width: 80px; margin-left: auto"
                          />
                        </ValidationProvider>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
                <v-divider />
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </ValidationObserver>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import MaterialCategories from "@/api/material_categories";
import MaterialSupplier from "@/api/supplier_materials";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    mode: String,
    value: Array,
  },
  computed: {
    isNew() {
      return this.mode == "new";
    },

    materialCategoriesFiltered() {
      var materialCategories = JSON.parse(
        JSON.stringify(this.materialCategories)
      );
      // console.log("materialCategories",materialCategories);
      // console.log(this.getMaterialCategoriesFiltered(materialCategories));
      return this.getMaterialCategoriesFiltered(materialCategories);
    },
    ...mapState(["settings"]),
  },

  data: () => ({
    materialCategoriesSearch: "",
    materialCategoriesLoading: false,
    materialCategories: [],
    active: [],
    open: [],
    materials: [],
    materialsLoading: false,
    orderDetailsMap: {},

    materialCategoriesCurrent: null,
  }),

  mounted() {
    this.getMaterialCategoriesFromAPI();
  },

  methods: {
    itemNumChange(item, num) {
      // console.log(item, num);
      var detail = this.orderDetailsMap[item.material_id];
      // num = this.$numberFormatter.formatWithDotNoMoreThan(num,2)
      if (num.length == 0) {
        num = "";
      } else {
        num = this.$numberFormatter.formatWithDotNoMoreThan(num, 2);
      }

      if (detail) {
        switch (this.mode) {
          case "new": // 新建
            detail.new_supply_price = num;
            break;
          case "edit": // 编辑
            detail.new_supply_price = num;
            break;
        }
        this.$emit("update", { material: detail });
      } else this.$emit("add", { material: item, num: num });
    },

    getMaterialCategoriesFromAPI() {
      this.materialCategoriesLoading = true;
      MaterialCategories.quotationTree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materialCategories = response.data.categories;
            }
            this.materialCategoriesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialCategoriesLoading = false;
          }.bind(this)
        );
    },

    getMaterialCategoriesFiltered(categories) {
      // console.log("categories",categories);
        return categories.filter((category) => {
          category.categories = this.getMaterialCategoriesFiltered(category.categories); // 递归下级分类
          if (
            (category.categories && category.categories.length > 0) || // 下级分类中有挂商品的
            (category.number && Number(category.number) > 0) // 和自身有挂商品的
          )
            return true; // 符合筛选条件
        });
    },
    // 右边商品
    getMaterialsFromAPI() {
      this.materialsLoading = true;
      MaterialSupplier.fetchByCategory({
        category_code: this.active[0].code,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materials = response.data.materials;

              this.attachOrderDetailToMaterial();
            }
            this.materialsLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.materialsLoading = false;
          }.bind(this)
        );
    },
    attachOrderDetailToMaterial() {
      if (this.materials && this.value) {
        this.orderDetailsMap = {};
        this.value.forEach((detail) => {
          var material = this.materials.find(
            (material) => material.material_id == detail.material_id
          );
          if (material) {
            this.orderDetailsMap[detail.material_id] = detail;
          }
        });
      }
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      deep: true,
      handler() {
        this.attachOrderDetailToMaterial();
      },
    },
    materialCategoriesFiltered: {
      handler() {
        // console.log(this.materialCategoriesFiltered);
        if (this.materialCategoriesFiltered.length > 0)
          this.active = [this.materialCategoriesFiltered[0]];
        else this.active = [];
      },
    },

    active: {
      handler() {
        if (this.active.length == 0 && this.materialCategoriesCurrent)
          this.active = [this.materialCategoriesCurrent];

        this.active.forEach((element) => {
          if (!this.open.find((e) => e == element)) this.open.push(element);
        });
        this.materialCategoriesCurrent = this.active[0];
      },
    },

    materialCategoriesCurrent: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.materialCategoriesCurrent) this.getMaterialsFromAPI();
      },
    },
  },
};
</script>

<style>
</style>